<template>
  <div>
    <el-card style="min-height: 45rem">
      <div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-input v-model="searchForm.keyword" placeholder="所属用户及激活用户昵称/ID/手机号;编号；激活码"></el-input>
          </el-col>
          <el-col :span="6">
            <el-select v-model="searchForm.bind_state">
              <el-option label="全部" :value="0"></el-option>
              <el-option label="空码" :value="1"></el-option>
              <el-option label="已绑定" :value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="searchForm.use_state">
              <el-option label="全部" :value="0"></el-option>
              <el-option label="未使用" :value="1"></el-option>
              <el-option label="已使用" :value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10">
            <el-date-picker
                style="width: 100%;margin-top: 1rem"
                v-model="searchForm.time"
                type="daterange"
                range-separator="至"
                start-placeholder="创建时间范围开始日期"
                end-placeholder="创建时间范围结束日期">
            </el-date-picker>
          </el-col>
          <el-col :span="8">
            <div class="flex-def flex-zBetween" style="margin-top: 1rem">
              <el-button-group>
                <el-button @click="searchGo" type="primary">搜索</el-button>
                <el-button @click="searchReset">重置</el-button>
              </el-button-group>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="flex-def" style="margin-top: 1rem">
              <y-user-choose @change="selectBind" :disable="!(selectCodeIds.length > 0)">
                <el-button :disabled="!(selectCodeIds.length > 0)">批量绑定用户</el-button>
              </y-user-choose>
              <create-code style="margin-left: 10px" @created="load">
                <el-button type="success">添加空码</el-button>
              </create-code>
              <el-button style="margin-left: 10px" type="danger" @click="exportExcel">导出</el-button>
            </div>
          </el-col>
        </el-row>

      </div>
      <el-table @selection-change="selectionChange" :data="list">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="code" label="激活码"></el-table-column>
        <el-table-column prop="sn_code" label="激活码编号"></el-table-column>
        <el-table-column label="所属用户" width="200">
          <template #default="s">
            <div class="flex-def" v-if="s.row.creator.id > 0">
              <img v-if="s.row.creator.avatar" :src="s.row.creator.avatar | tomedia"
                   style="height: 3rem;width: 3rem;border-radius: 5px;margin-right: 10px" alt="">
              <div>
                <div>{{ s.row.creator.nickname }}({{ s.row.creator.id }})</div>
                <div>{{ s.row.creator.phone }}</div>
              </div>
              <div>
                <el-button size="mini" type="danger" @click="clear(s.row)">解绑</el-button>
              </div>
            </div>
            <div v-else>
              <y-user-choose @change="bindUid($event,s.row.id)">
                <el-button type="success" style="width: 100%">绑定用户</el-button>
              </y-user-choose>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="激活用户" width="200">
          <template #default="s">
            <div class="flex-def" v-if="s.row.use_user.id > 0">
              <img v-if="s.row.use_user.avatar" :src="s.row.use_user.avatar | tomedia"
                   style="height: 3rem;width: 3rem;border-radius: 5px;margin-right: 10px" alt="">
              <div>
                <div>{{ s.row.use_user.nickname }}({{ s.row.use_user.id }})</div>
                <div>{{ s.row.use_user.phone }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="使用状态">
          <template #default="s">
            <span :style="`color: ${s.row.used ? 'red' : '#3cc51f'}`">{{ s.row.used ? '已使用' : '未使用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="生成时间">
          <template #default="s">{{ s.row.created_at | date }}</template>
        </el-table-column>
        <el-table-column prop="used_order_id" label="激活订单编号"></el-table-column>
        <el-table-column label="激活时间">
          <template #default="s">{{ s.row.used_time | date }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="s">
            <div class="flex-def">
              <el-button style="margin-left: 10px" type="danger" plain @click="del(s.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <template #append>
          <el-pagination style="padding: .5rem" background layout="total,prev, pager,next"
                         :total="total" :page-size="15" :current-page="page" @current-change="pageChange">
          </el-pagination>
        </template>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import CreateCode from "@/view/card/plugin/cdkey/createCode.vue";
import YUserChoose from "@/components/user/YUserChoose.vue";

let SearchFormTpl = {
  keyword: "",
  bind_state:0,
  use_state:0,
  time: [],
}
export default {
  components: {YUserChoose, CreateCode},

  data() {
    return {
      list: [],
      page: 1,
      total: 0,
      size: 15,
      searchForm: {...SearchFormTpl},
      selectCodeIds:[],
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    searchGo() {
      this.page = 1;
      this.list = [];
      this.load();
    },
    searchReset() {
      this.searchForm = {...SearchFormTpl}
      this.searchGo()
    },
    selectionChange(e){
      let arr = [];
      e.forEach(item=>{
        arr.push(item.id)
      })
      this.selectCodeIds = arr;
    },
    selectBind(u){
      this.$u.api.card.plugin.cdkey.uidBindCodeIds({
        uid:u.id,
        code_ids:this.selectCodeIds
      }).then(()=>{
        this.$message.success("操作成功");
        this.load();
      })
    },
    bindUid(u,codeId){
      this.$u.api.card.plugin.cdkey.uidBindCodeIds({
        uid:u.id,
        code_ids:[codeId]
      }).then(()=>{
        this.$message.success("操作成功");
        this.load();
      })
    },
    clear({id}){
      this.$u.api.card.plugin.cdkey.clear({id}).then(()=>{
        this.$message.success("操作成功");
        this.load();
      })
    },
    del({id}) {
      this.$u.api.card.plugin.cdkey.del({id}).then(()=>{
        this.$message.success("操作成功");
        this.load();
      })
    },
    exportExcel() {
      this.$u.api.card.plugin.cdkey.export({
        ...this.searchForm,
      }).then(res => {
        window.open(res, "_blank")
      })
    },
    load() {
      this.$u.api.card.plugin.cdkey.search({
        page: this.page,
        ...this.searchForm,
      }).then(res => {
        this.list = res.list;
        this.total = res.total;
      })
    },
    pageChange(e) {
      this.page = e;
      this.load();
    }
  }
}
</script>

<style scoped>

</style>